module.exports = __webpack_public_path__ + "static/img/cart-no.686d8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart-no.png
// module id = VmlR
// module chunks = 1